/* eslint-disable import/no-cycle */
/* eslint-disable no-underscore-dangle */
import jwt_decode from 'jwt-decode'; // eslint-disable-line camelcase
import AWS from 'aws-sdk';
import * as Sentry from '@sentry/react';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

import { CrossStorageClient } from 'cross-storage';
import { setHeaders } from '../config/axios';

import { LOGIN_ROUTE, BASENAME } from '../constants/RouterConstants';
import { fetchBackendUrl } from '../constants';

const isLocal = window.location.hostname.indexOf('local') === 0;
const hostName = window.location.hostname.split(':')[0];
const href = window.location.href.split('#');
const hashmap = new Map(window.location.hash.substring(1).split('&').map(obj => [obj.split('=')[0], obj.split('=')[1]]));
const tokensInHash = hashmap.has('access_token');
const emailInHash = hashmap.has('email');

const REFRESH_INTERVAL = 3000 * 1000; // Miliseconds
const SSO_ENABLED = process.env.REACT_APP_SSO_ENABLED === 'true' ? true : isLocal;
let instance = null;

export default class PortalAuth {
  constructor() {
    if (!instance) {
      this.getAuthToken = this.getAuthToken.bind(this);
      this.setAuthToken = this.setAuthToken.bind(this);

      this.refreshUserToken = this.refreshUserToken.bind(this);
      this.refresherAction = this.refresherAction.bind(this);

      this.isAuthenticated = this.isAuthenticated.bind(this);
      this.isTokenExpired = this.isTokenExpired.bind(this);
      this.decodeToken = this.decodeToken.bind(this);
      this.csOnConnect = this.csOnConnect.bind(this);
      this.csOnReject = this.csOnReject.bind(this);

      this.logout = this.logout.bind(this);
      this.loginRoute = PortalAuth.loginRoute.bind(this);

      this.storage = window.localStorage;
      this.crossStorage = new CrossStorageClient(`https://api.${isLocal ? 'dev.aerosimple.com' : hostName.slice(hostName.indexOf('.') + 1)}/hub`);
      // this.crossStorage.onConnect().then(this.csOnConnect, this.csOnReject); // not used as of now
      this.refresher = null;

      this.userPool = new CognitoUserPool({
        UserPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
        ClientId: `${process.env.REACT_APP_COGNITO_CLIENT_ID}`
      });
      instance = this;
    }
    return instance;
  }

  static getInstance() {
    if (instance === null) {
      instance = new PortalAuth();
    }
    if (!instance.isAuthenticated()) {
      instance.loginRoute();
    }
    if (this.refresher === null) {
      this.refresher = setInterval(this.refresherAction, REFRESH_INTERVAL);
    }
    return instance;
  }

  getUserPool() {
    return this.userPool;
  }

  /*
   Returns JWT for the backend authentication.
   @returns {String} JWT.
  */
  getAuthToken() {
    return this.storage.getItem('token');
  }

  /*
   Returns ID token
   @returns {String} IDToken.
  */
  getIDToken() {
    return this.storage.getItem('idtoken');
  }

  /*
   Stores the JWT in the browser.
   @returns {String} token.
  */
  _setAuthToken(newToken) {
    setHeaders(newToken);
    this.storage.setItem('token', newToken);
    if (this.refresher === null) {
      this.refresher = setInterval(this.refresherAction, REFRESH_INTERVAL);
    }
    return newToken;
  }

  /*
   Stores the IDToken in the browser.
   @returns {String} token.
  */
  setIDToken(newToken) {
    this.storage.setItem('idtoken', newToken);
    return newToken;
  }

  csOnReject() {
    if (this.isAuthenticated()) {
      window.location.reload();
    } else {
      this.loginRoute();
    }
  }

  csOnConnect() {
    this.crossStorage.get('token').then((res) => {
      if (SSO_ENABLED && res !== undefined
        && res !== this.getAuthToken() && !this.isTokenExpired(res)) {
        this._setAuthToken(res);
        window.location.reload();
      } else if (this.isAuthenticated()) {
        this.crossStorage.set('token', this.getAuthToken()).then();
      } else if (!window.location.pathname.includes('conditions')) {
          this.loginRoute();
      }
    });
  }

  static loginRoute() {
    if (!window.location.href.endsWith(LOGIN_ROUTE)) {
      let conditionIndex = window.location.pathname.includes('conditions');
      let ssreportIndex = window.location.pathname.includes('ssreport');
      let formIndex = window.location.pathname.includes('forms/');
      let noiseIndex = window.location.pathname.includes('noise_log/');
      let smsIndex = window.location.pathname.includes('safety_management/');
      let waitListIndex = window.location.pathname.includes('wait_list/');
      let lmsIndex = window.location.pathname.includes('lms/');
      const publicBadgeLoginIndex = window.location.pathname.includes('auth/badging/login/');
      let adpIndex = window.location.pathname.includes('auth/adp/');
      let non_airfieldIndex = window.location.pathname.includes('non-airfield/');
      let badgeScheduleIndex = window.location.pathname.includes('badge/scheduling/');
      let gateMgntIndex = window.location.pathname.includes('gate_managment/');
      let permitCompanyRegistration = window.location.pathname.includes('company_registration');
      let emailLoginIndex = window.location.pathname.includes('email/login');
      let idpLogin = window.location.pathname.includes(`${process.env.REACT_APP_IDP_LOGIN_URL}`) || window.location.href.includes('#access_token=');
      if (!conditionIndex && !formIndex && !noiseIndex && !smsIndex && !publicBadgeLoginIndex && !non_airfieldIndex && !adpIndex && !gateMgntIndex
        && !badgeScheduleIndex && !ssreportIndex && !permitCompanyRegistration && !emailLoginIndex && !idpLogin && !waitListIndex && !lmsIndex) {
        this.storage.setItem('portalRedirectUrl', window.location.href.replace(LOGIN_ROUTE, ''));
        window.location.href = BASENAME + LOGIN_ROUTE;
      }
    }
  }


  static updateAwsAuth = () => {
    const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;
    AWS.config.update({
        region: process.env.REACT_APP_REGION,
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
            Logins: {
                [key]: PortalAuth.getInstance().getIDToken()
            }
        })
    });
  }

  setAuthToken(newToken) {
    this._setAuthToken(newToken);
    // this.crossStorage.set('token', newToken).then();
  }

  refreshUserToken() {
    const cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          this.cleanStorage();
          clearInterval(this.refresher);
          return;
        }
        cognitoUser.refreshSession(session.getRefreshToken(), (error, newSession) => {
          if (error) {
            this.cleanStorage();
            clearInterval(this.refresher);
            return;
          }
          this.setAuthToken(newSession.getAccessToken().getJwtToken());
          this.setIDToken(newSession.getIdToken().getJwtToken());
        });
      });
    } else {
      this.cleanStorage();
    }
  }

  /* Indicates if a user is logged in.
   @returns {Boolean} Returns True if a user's token has not expired, and False otherwise.
  */
  isAuthenticated() {
    const res = !this.isTokenExpired();
    if (!res) {
      this.cleanStorage();
    }
    return res;
  }

  /*
   Returns True if the stored token has expired
   @returns {Boolean}
  */
  isTokenExpired(token=this.getAuthToken()) {
    const decoded = this.decodeToken(token);
    if (!decoded || typeof decoded.exp === 'undefined') {
      return true;
    }
    const d = new Date(0);
    d.setUTCSeconds(decoded.exp);
    if (d === null) {
      return true;
    }
    return ((new Date().valueOf()) > d.valueOf());
  }

  /*
   Decodes stored JWT.
   Does not validate signature.
   @returns {Object} Token decodificado.
  */
  decodeToken(token=this.getAuthToken()) {
    let decoded;
    try {
      decoded = jwt_decode(token);
    } catch (err) {
      decoded = null;
    }
    return decoded;
  }

  /*
   Clears user information.
  */
  logout() {
    this.cleanStorage();
    clearInterval(this.refresher);
    // this.crossStorage.del('token').then(this.loginRoute);
  }

  /*
  Clears token from storage
  */
  cleanStorage() {
    this.storage.removeItem('token');
    // this.crossStorage.del('token').then();
    const cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      cognitoUser.signOut();
    }
  }

  refresherAction() {
    if (this.isAuthenticated()) {
      this.refreshUserToken();
    }
  }


  startRefresher() {
    if (emailInHash) {
      const email = hashmap.get('email');
      if (this.isAuthenticated()) {
        if (window.history.pushState) {
          window.history.pushState('', '/', window.location.pathname);
        } else {
          window.location.hash = '';
        }
      } else {
        window.location.href = `${process.env.REACT_APP_IDP_LOGIN_URL
        }&idp_identifier=${email.split('@')[1]
        }&redirect_uri=${window.location.origin}${window.location.pathname}`;
      }
    } else if (tokensInHash) {
      localStorage.setItem('token', hashmap.get('access_token'));
      try {
        localStorage.setItem('idtoken', hashmap.get('id_token'));
      } catch (error) {
        const email = localStorage.getItem('userEmail') || '';
        const domain = email?.split('@')[1] || '';
        const scope = Sentry.getCurrentScope();
        scope.setTag('user.email_domain', domain);
        scope.setTag('user.email', email);
        Sentry.captureException(error);
        // do nothing
      }
      if (!localStorage.getItem('appBackendApi')) {
        fetchBackendUrl().then(() => {
          const redirUrl = localStorage.getItem('redirectUrl');
          const state = hashmap.get('state');
          const refurl = state !== undefined ? href[0] + state : href[0];
          window.location.href = redirUrl !== null ? redirUrl : refurl;
        })
          .catch(() => {
          // do nothing
          });
      } else {
        const redirUrl = localStorage.getItem('redirectUrl');
        const state = hashmap.get('state');
        const refurl = state !== undefined ? href[0] + state : href[0];
        window.location.href = redirUrl !== null ? redirUrl : refurl;
      }
    }
    if (this.refresher === null) {
      const decoded = this.decodeToken();
      if (decoded !== null) {
        const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
        date.setUTCSeconds(decoded.exp);

        const now = new Date();
        const secondsUntilExpiration = Math.floor((date - now) / 1000);
        if (secondsUntilExpiration < 600) {
          this.refresherAction();
        } else if (secondsUntilExpiration < REFRESH_INTERVAL / 1000) {
          this.refresher = setInterval(this.refresherAction, (secondsUntilExpiration - 120) * 1000);
        } else {
          this.refresher = setInterval(this.refresherAction, REFRESH_INTERVAL);
        }
      } else {
        this.refresher = setInterval(this.refresherAction, REFRESH_INTERVAL);
      }
    }
  }
}

PortalAuth.getInstance().startRefresher();
